<template>
  <div class='h100-40 h-scroll'>
    <ejs-grid ref='grid' :dataSource='dataForList' height='calc(100% - 0px)' :rowSelected='rowSelected' :rowDeselected='rowDeselected'>
      <e-columns>
        <e-column field='sysMeterTaskId' :headerText='$t("Pm.taskID")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='sysMeterTaskName' :headerText='$t("Pm.taskName")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='meterTimePeriod' :headerText='$t("Pm.measureCycle")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :valueAccessor='cycleFormat'></e-column>
        <e-column field='sysMeterTaskDepict' :headerText='$t("Pm.taskDescription")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='sysMeterTaskStatus' :headerText='$t("Pm.consistentState")' textAlign='Center' width='8%' clipMode='EllipsisWithTooltip' :valueAccessor='consistentFormat'></e-column>
        <e-column field='meterStatus' :headerText='$t("Pm.taskState")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter="formatterOftaskStatus"></e-column>
        <e-column field='effectiveTimeMode' :headerText='$t("Pm.timeMode")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :valueAccessor='timeModeFormat'></e-column>
        <e-column field='meterBegTime' :headerText='$t("Pm.start_time")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='meterEndTime' :headerText='$t("Pm.end_time")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='meterSynchroTime' :headerText='$t("Pm.syncTime")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='meterRestStartTime' :headerText='$t("Pm.hangUpStartTime")' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='meterRestEndTime' :headerText='$t("Pm.hangUpEndTime")' textAlign='Center' width='9%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='sysMeterTaskEditPeople' :headerText='$t("Pm.editor")' textAlign='Center' width='5%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='sysMeterTaskEditTime' :headerText='$t("Pm.editTime")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pagerOfTaskListForNoReal' @click='getTaskListOfTaskListFOrNoReal()' :currentPage='page.currentPage' :pageCount='page.pageCount' :pageSize='page.pageSize' :totalRecordsCount='page.totalRecordsCount'></ejs-pager>
  </div>
</template>

<script>
import { Reorder, Resize, ContextMenu } from '@syncfusion/ej2-vue-grids';

export default {
  name: 'TaskListForNoReal',
  props: [
    'queryParams', // 存放网元树或测量对象树点击信息，树类型通过treeType字段来区分，1：测量对象树 2：网元树
    'tableType'
  ],
  data() {
    return {
      dataForList: [],
      page: {
        currentPage: 1,
        pageSize: 25,
        totalRecordsCount: 0,
        pageCount: 10
      },
      rowData: '',
      meterTimePeriods: new Map()
        .set(300000, this.$t('Pm.fiveMinutes'))
        .set(900000, this.$t('Pm.fifteenMinutes'))
        .set(1800000, this.$t('Pm.thirtyMinutes'))
        .set(3600000, this.$t('Pm.oneHour'))
        .set(86400000, this.$t('Pm.oneDay')),
      consistents: new Map()
        .set('0', this.$t('Pm.inconsistent'))
        .set('1', this.$t('Pm.consistent')),
      taskStatus: new Map()
        .set(0, this.$t('Pm.hangup'))
        .set(1, this.$t('Pm.active'))
        .set(2, this.$t('Pm.failure')),
      timeMods: new Map()
        .set('0', this.$t('Pm.periodTime'))
        .set('1', this.$t('Pm.longTime'))
    };
  },
  methods: {
    rowSelected(msg) {
      this.rowData = msg.data;
      this.$emit('taskStatusChange', msg.data.meterStatus);
    },
    rowDeselected() {
      this.rowData = '';
    },
    initTaskList(msg) {
      const This = this;
      This.page.currentPage = This.$refs.pagerOfTaskListForNoReal.ej2Instances.currentPage;
      if (msg) {
        this.$loading.showLoadding(this.$t('System.loading'));
        if (msg.treeType == 1) {
          this.$axios.post('/lte/pm/measuretaskmanagement/getTaskListDataFromMeasureObj.html', {
            configSysMeterTask: {},
            counterTypeId: msg.counterTypeId ? msg.counterTypeId : '',
            measureObjectTypeCode: msg.measureObjectTypeCode ? msg.measureObjectTypeCode : '',
            neTypeId: msg.neTypeId ? msg.neTypeId : '',
            page: {
              pageNo: This.page.currentPage,
              pageSize: This.page.pageSize
            },
            systemId: 1
          }).then((response) => {
            const result = response.data.resultVal;
            This.page.totalRecordsCount = result.totalCount;
            This.page.currentPage = result.pageNo;
            This.dataForList = result.result;
            this.$loading.hideLoadding();
          });
        } else {
          this.$axios.post('/lte/pm/measuretaskmanagement/getTaskListDataFromNe.html', {
            configSysMeterTask: {},
            neId: msg.neId ? msg.neId : '',
            neTypeId: msg.neTypeId ? msg.neTypeId : '',
            page: {
              pageNo: This.page.currentPage,
              pageSize: This.page.pageSize
            },
            systemId: 1
          }).then((response) => {
            const result = response.data.resultVal;
            This.page.totalRecordsCount = result.totalCount;
            This.page.currentPage = result.pageNo;
            This.dataForList = result.result;
            this.$loading.hideLoadding();
          });
        }
      }
    },
    getTaskListOfTaskListFOrNoReal(queryCondition) {
      const This = this;
      This.page.currentPage = This.$refs.pagerOfTaskListForNoReal.ej2Instances.currentPage;
      if (this.tableType == 1) {
        this.$loading.showLoadding(this.$t('System.loading'));
        this.$axios.post('/lte/pm/measuretaskmanagement/getTaskListDataFromMeasureObj.html', {
          configSysMeterTask: {},
          counterTypeId: this.queryParams.counterTypeId ? this.queryParams.counterTypeId : '',
          measureObjectTypeCode: this.queryParams.measureObjectTypeCode ? this.queryParams.measureObjectTypeCode : '',
          neTypeId: this.queryParams.neTypeId ? this.queryParams.neTypeId : '',
          page: {
            pageNo: This.page.currentPage,
            pageSize: This.page.pageSize
          },
          systemId: 1,
          queryStr: queryCondition || ''
        }).then((response) => {
          const result = response.data.resultVal;
          This.page.totalRecordsCount = result.totalCount;
          This.page.currentPage = result.pageNo;
          This.dataForList = result.result;
          this.$loading.hideLoadding();
        });
      } else {
        this.$axios.post('/lte/pm/measuretaskmanagement/getTaskListDataFromNe.html', {
          configSysMeterTask: {},
          neId: this.queryParams.neId ? this.queryParams.neId : '',
          neTypeId: this.queryParams.neTypeId ? this.queryParams.neTypeId : '',
          page: {
            pageNo: This.page.currentPage,
            pageSize: This.page.pageSize
          },
          systemId: 1,
          queryStr: queryCondition || ''
        }).then((response) => {
          const result = response.data.resultVal;
          This.page.totalRecordsCount = result.totalCount;
          This.page.currentPage = result.pageNo;
          This.dataForList = result.result;
          this.$loading.hideLoadding();
        });
      }
    },
    cycleFormat(field, cycleData) {
      return this.meterTimePeriods.get(cycleData[field]);
    },
    consistentFormat(field, consistentData) {
      return this.consistents.get(consistentData[field]);
    },
    timeModeFormat(field, timeModeData) {
      return this.timeMods.get(timeModeData[field]);
    },
    formatterOftaskStatus(grids, data) {
      let color = '';
      switch (data.meterStatus) {
        case 0:
          color = 'red';
          break;
        case 1:
          color = 'green';
          break;
        case 2:
          color = 'gray';
          break;
        default:
          break;
      }
      return `<span style='background-color:${color};font-size: 12px;display: inline-block;width: 55px;height: 22px;color: #fff;line-height: 22px;' >${this.taskStatus.get(data.meterStatus)}</span>`;
    }
  },
  mounted() {
    this.initTaskList({ treeType: '1' });
  },
  provide: {
    grid: [Reorder, Resize, ContextMenu]
  }
};
</script>

<style>

</style>
